import axios from 'axios'

export const state = {
  countries: [],
  states: []
}

export const getters = {
  listCountries (state) {
    return state.countries
  },
  listStates (state) {
    return state.states
  }
}

export const mutations = {
  SET_COUNTRIES (state, countries) {
    state.countries = countries
  },
  SET_STATES (state, states) {
    state.states = states
  },
}

export const actions = {
  getCountries({ commit }, params = {
    orderBy: 'order',
    sortedBy: 'asc',
    limit: 500,
  }) {
    axios.get(`/countries/search`, { params }).then(({ data }) => {
      commit('SET_COUNTRIES', data)
    })
  },
  getStates({ commit }, code) {
    axios.get(`/countries/` + code + '/states').then(({ data }) => {
      commit('SET_STATES', data)
    })
  },
  getListCountries({ commit }, params = {}) {
    return axios.get('/countries/search', { params })
  },
}
